import React, { useEffect, useState, lazy, Suspense } from 'react'
import {Router, Route, Switch, Redirect} from 'react-router-dom'
// import {history} from "./history"

import {auth} from './Auth'
import {db, firebase, firebaseAuth} from './utilities'
import {signInWithCustomToken} from 'firebase/auth'

import './styles.css'

// Always-rendered shell components (not lazy)
// import NotFound from './NotFound'
import CheckRegistration from './CheckRegistration'
// import Header from "./Sidebar/Header"
import Sidebar from './Sidebar'
import SystemNotifier from './Logging/SystemNotifier'
import Badge from './Badge'

import {history} from './history'
import AppContext, { initialListFilters } from './AppContext'

// Route-level lazy imports — each route loads its own JS chunk on first visit
const GarbageProjectExporter = lazy(() => import('./GarbageProjectExporter'))
const Login = lazy(() => import('./Login'))
//const Register = lazy(() => import('./Register'))
const ScheduleInspections = lazy(() => import('./ScheduleInspectionsNew/TopLevelState'))
const SystemSettings = lazy(() => import('./SystemSettings'))
const ProjectList = lazy(() => import('./ProjectList/TopLevelState'))
const ProjectInspectionsList = lazy(() => import('./ProjectList/ProjectsInspections'))
const ProjectRequestsList = lazy(() => import('./ProjectList/ProjectsRequests'))
const UserList = lazy(() => import('./UserList/TopLevelState'))
const Rubrics = lazy(() => import('./Rubrics'))
const FormsList = lazy(() => import('./FormList/FormsList'))
const FormEdit = lazy(() => import('./FormDetail/Provider'))
const VersionsList = lazy(() => import('./FormReadOnly/VersionsList'))
const FormReadOnly = lazy(() => import('./FormReadOnly/Provider'))
const RubricsReadOnly = lazy(() => import('./RubricsReadOnly/Provider'))
const DetailedProjectView = lazy(() => import('./DetailedProjectView').then(m => ({default: m.DetailedProjectView})))
const DetailedUserView = lazy(() => import('./DetailedUserView').then(m => ({default: m.DetailedUserView})))
const Dashboard = lazy(() => import('./Dashboards/DashboardLanding'))
const ProjectNotifications = lazy(() => import('./ProjectNotifications'))
const ScoringSystemsPage = lazy(() => import('./ScoringSystems/ScoringSystemsPage'))
const PdfTest = lazy(() => import('./PdfTest'))
// const Testing = lazy(() => import('./Testing'))
const AutocompleteField = lazy(() => import('./AutocompleteField'))
const EmailLogin = lazy(() => import('./EmailLogin'))
const DoIntake = lazy(() => import('./DoIntake'))
const Calendar = lazy(() => import('./Calendar/Calendar'))
// const Reports = lazy(() => import('./Reports/TopLevelState'))
const Reports = lazy(() => import('./Reports'))
const FieldUserDirectory = lazy(() => import('./FieldUserDirectory'))
const InstallerDirectory = lazy(() => import('./InstallerDirectory'))
const Analytics = lazy(() => import('./Analytics/TopLevelState'))
const Testbed = lazy(() => import('./Testbed'))
const TicketModal = lazy(() => import('./TicketBuilder'))
const TicketPage = lazy(() => import('./TicketDetail'))
const TicketList = lazy(() => import('./TicketList'))
const ProjectNotification = lazy(() => import('./ProjectNotification'))
const TestHOC = lazy(() => import('./HOC/TestHOC'))
const Authorizations = lazy(() => import('./Authorizations'))
const NewLogin = lazy(() => import('./NewLogin'))
const ProjectLogs = lazy(() => import('./ProjectLogs'))
const Utilities = lazy(() => import('./UtilitiesRoutes'))
const ProjectViewer = lazy(() => import('./ProjectViewer'))
const CreateClient = lazy(() => import('./CreateClient'))
const Clients = lazy(() => import('./Clients/ClientUsers'))
// const history = createBrowserHistory()

const admins = ['admin', 'super-admin', 'client']
const inspectors = ['field-user', 'quality-manager']

const styles = {sidebar: {width: '18%'}, content: {flex: 80}, container: {flex: 1}}

export const Landing = () => <h1>Click the Sign In button on the left sidebar to get started</h1>

function Authorized({component: Component, ...rest}) {
  return <Route {...rest} render={(props) => <CheckRegistration {...{Component, ...rest, ...props}} />} />
}

function RedirectToUserManage() {
  return <Redirect to={`/users/${auth.sunkaizenUser.id}/manage`} />
}

export default function App() {
  const [listFilters, setListFilters] = useState({...initialListFilters});
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);


  useEffect(() => {

    //console.log('auth.sunkaizenUser.id',auth?.sunkaizenUser?.id)
    /*
    const token = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJodHRwczovL2lkZW50aXR5dG9vbGtpdC5nb29nbGVhcGlzLmNvbS9nb29nbGUuaWRlbnRpdHkuaWRlbnRpdHl0b29sa2l0LnYxLklkZW50aXR5VG9vbGtpdCIsImlhdCI6MTc3OTk2NjYyOCwiZXhwIjoxNzc5OTcwMjI4LCJpc3MiOiI3MTIzMjg5OTg4NTItY29tcHV0ZUBkZXZlbG9wZXIuZ3NlcnZpY2VhY2NvdW50LmNvbSIsInN1YiI6IjcxMjMyODk5ODg1Mi1jb21wdXRlQGRldmVsb3Blci5nc2VydmljZWFjY291bnQuY29tIiwidWlkIjoiczUxUWIzWmFncFd4QUdINUZYMzkifQ.c3zKnHkRnnxa-7iaVIIWjNdV0e-TUvuFqnZzkxhDitsRr8sKYH03mChU6sWpH-M4s9bwyYSxuTYViwNoBNttiUoOPZ3IEpfBY71Ekmk7rhd3_NclkxGdJAof2O4HczcKEiprgMhk1VW1deSz_7_SR5ofbLBpMSQp6KEJRNMvB4ZKUdpwE8M-vHUJt5K50dsu1l-JGO4D8Hmq75m-cS9yLMyrMnZZf2lTlUPDimYlE06HisCFxDZbNNaEo1OTFtxny_-sgVfJjlG5hjR1oNKa1hfDQD9uzbgLw5-aXtRHJq6FVw_ZgNyI6DbEe_jpTWnlnCjEiBawxrl3vre61qkPTQ"
      signInWithCustomToken(firebaseAuth, token)
        .then((userCredential) => {
          console.log("Login successful", userCredential.user);
        })
        .catch((error) => {
          console.error("Error signing in with custom token", error);
        });
  */
   
  })

  return (
    <>
    <AppContext.Provider value={{listFilters, setListFilters}}>
    {!isOnline && (
      <div style={{
        position: 'fixed', bottom: 0, left: 0, right: 0,
        background: '#c0392b', color: '#fff',
        textAlign: 'center', padding: '10px 16px',
        fontWeight: 600, fontSize: 14, letterSpacing: 0.3,
        zIndex: 99999,
      }}>
        No internet connection — changes may not be saved.
      </div>
    )}
    <Badge/>
    <Router history={history}>
      
      <div className="app" style={{display: `flex`, flexFlow: `row nowrap`}}>
        <SystemNotifier />
        <div style={styles.sidebar}>
          <Route path="/" component={Sidebar} />
        </div>
        <div className="flex-column background-secondary" style={{width: `82%`, overflowY: 'scroll'}}>
          <div className="flex-colum align-start" style={styles.content}>
            <div className="full-height">
              <Suspense fallback={<div style={{padding: 24}}>Loading...</div>}>
              <Switch>
                <Route exact path="/invite/:specialurl" component={CreateClient} />
                <Route path="/organization/:organization" component={Namespaced} />
                <Route path="/utilities" component={Utilities} />
                <Route exact path="/new_login/:email/:code" component={NewLogin} />
                <Route exact path="/landing" component={Landing} />
                <Route exact path="/login" component={Login} />
                {/* <Route exact path="/register" component={Register} /> */}
                <Route exact path="/emailLogin" render={() => <EmailLogin auth={auth} />} />
                <Authorized exact path="/" component={Dashboard} />
                <Authorized exact path="/analytics" type={admins} component={Analytics} />
                <Authorized exact path="/schedule" type={[...admins, `scheduler`]} component={ScheduleInspections} />
                <Authorized exact path="/forms" type={admins} component={FormsList} />
                <Authorized exact path="/scoringSystems" type={admins} component={ScoringSystemsPage} />
                <Authorized exact path="/tickets" component={TicketList} />
                <Authorized exact path="/ticketModal" component={TicketModal} />
                <Authorized exact path="/projects" component={ProjectList} />
                <Authorized exact path="/users" type={admins} component={UserList} />
                <Authorized exact path="/clients" type={admins} component={Clients} />
                <Authorized exact path="/authorizations" type={admins} component={Authorizations} />
                <Authorized exact path="/calendar" component={Calendar} />
                <Authorized exact path="/reports" component={Reports} type={[...admins, 'scheduler']} />
                <Authorized exact path="/field_users" type={admins} component={FieldUserDirectory} />
                <Authorized exact path="/installers" type={admins} component={InstallerDirectory} />
                <Authorized exact path="/autocompletetest" component={AutocompleteField} />
                <Authorized exact path="/testhoc" component={TestHOC} />
                <Authorized exact path="/pdftest" component={PdfTest} />
                <Authorized exact path="/testbed" component={Testbed} />
                <Authorized exact path="/project_viewer" types={['admin', 'super-admin']} component={ProjectViewer} />
                {/* <Authorized exact path='/newscheduleinspections' component={NewScheduleInspections} /> */}

                <Authorized exact path="/trash" component={GarbageProjectExporter} />
              </Switch>
              <Switch>
                <Route exact path="/settings/account" render={() => <RedirectToUserManage auth={auth} />} />
                <Authorized exact path="/tickets/:ticketId" component={TicketPage} />
                <Authorized exact path="/forms/:formId/rubrics" type={admins} component={Rubrics} />
                <Authorized exact path="/forms/:formId/versions" type={admins} component={VersionsList} />
                <Authorized exact path="/formarchive/:id" type={admins} component={FormReadOnly} />
                <Authorized exact path="/rubricsarchive/:id" type={admins} component={RubricsReadOnly} />
                <Authorized exact path="/settings/system" type={admins} component={SystemSettings} />
                <Authorized exact path="/forms/:id" type={admins} component={FormEdit} />
                <Authorized exact path="/projectNotifications/:id" component={ProjectNotifications} />
                <Authorized exact path="/notifications/:id" component={ProjectNotification} />
                <Authorized exact path="/projects/:id/manage" component={DetailedProjectView} />
                <Authorized exact path="/users/:id/manage" component={DetailedUserView} />
                <Authorized exact path="/intake/:id" type={[...admins, ...inspectors]} component={DoIntake} />
              </Switch>
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </Router>
    </AppContext.Provider>
    </>
  )
}

function transform(path) {
  return `/organization/:organization/${path}`
}
function Namespaced({location}) {
  return (
    <Suspense fallback={<div style={{padding: 24}}>Loading...</div>}>
    <div>
      <Switch>
        <Authorized exact path={transform('')} component={Dashboard} />
        <Authorized exact path={transform('analytics')} type={admins} component={Analytics} />
        <Authorized
          exact
          path={transform('schedule')}
          type={[...admins, `scheduler`, `field-user`]}
          component={ScheduleInspections}
        />
        <Authorized exact path={transform('create_client/:id')} component={CreateClient} />
        <Authorized exact path={transform('forms')} type={admins} component={FormsList} />
        <Authorized exact path={transform('scoringSystems')} type={admins} component={ScoringSystemsPage} />
        <Authorized exact path={transform('tickets')} component={TicketList} />
        <Authorized exact path={transform('projects')} component={ProjectList} />
        <Authorized exact path={transform('projects_inspections')} component={ProjectInspectionsList} />
        <Authorized exact path={transform('projects_requests')} component={ProjectRequestsList} />
        <Authorized exact path={transform('users')} type={admins} component={UserList} />
        <Authorized exact path={transform('clients')} type={admins} component={Clients} />
        <Authorized exact path={transform('authorizations')} type={admins} component={Authorizations} />
        <Authorized exact path={transform('calendar')} component={Calendar} />
        <Authorized exact path={transform('reports')} component={Reports} type={[...admins, ...inspectors, 'scheduler']} />
        <Authorized exact path={transform('field_users')} type={admins} component={FieldUserDirectory} />
        <Authorized exact path={transform('installers')} type={admins} component={InstallerDirectory} />
      </Switch>
      <Authorized exact path={transform('settings/account')} component={RedirectToUserManage} />
      <Authorized exact path={transform('settings/system')} type={admins} component={SystemSettings} />
      <Authorized exact path={transform('tickets/:ticketId')} component={TicketPage} />
      <Authorized exact path={transform('forms/:formId/rubrics')} type={admins} component={Rubrics} />
      <Authorized exact path={transform('forms/:formId/versions')} type={admins} component={VersionsList} />
      <Authorized exact path={transform('formarchive/:id')} type={admins} component={FormReadOnly} />
      <Authorized exact path={transform('rubricsarchive/:id')} type={admins} component={RubricsReadOnly} />
      <Authorized exact path={transform('forms/:id')} type={admins} component={FormEdit} />
      <Authorized exact path={transform('projectNotifications/:id')} component={ProjectNotifications} />
      <Authorized exact path={transform('notifications/:id')} component={ProjectNotification} />
      <Authorized
        exact
        path={transform('projects/:id/manage')}
        shared={['client', 'field-user']}
        component={DetailedProjectView}
      />
      <Authorized exact path={transform('users/:id/manage')} component={DetailedUserView} />
      <Authorized
        exact
        path={transform('intake/:id')}
        shared={['field-user']}
        type={[...admins, ...inspectors]}
        component={DoIntake}
      />
      <Authorized exact path={transform('projects/:id/logs')} component={ProjectLogs} />
    </div>
    </Suspense>
  )
}
